import React from 'react';
import clientConfig from 'universal-config';

let fbScriptRendered = false;

const FB_SDK_JS = `(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));`;

export class FacebookSDK extends React.Component {
  componentDidMount() {
    if (fbScriptRendered && !__TEST__) {
      return;
    }
    fbScriptRendered = true;

    const config = clientConfig();

    const sdkInitJs = `window.fbAsyncInit = function() {
      FB.init({
        appId: ${config && config.fb && config.fb.appId},
        xfbml : true,
        version : 'v2.10'
      });

      FB.getLoginStatus(function (response) {
        window._fbAuthResponse = response;

        var event = document.createEvent('Event');
        event.initEvent('facebookReady', true, true);
        document.body.dispatchEvent(event);
      });
    };`;

    const script = document.createElement('script');
    script.textContent = FB_SDK_JS + sdkInitJs;
    script.id = 'fb-js-root';
    document.body.appendChild(script);
  }

  render() {
    return false;
  }
}
